import React, { Component } from 'react'
import {Button} from 'antd'
import './index.scss'
export default class GuideItem extends Component {
  constructor(props){
    super(props)
    this.state={
        currentPage:1,
        top:'-100px',
        left:0
    }
    this.cancel = this.cancel.bind(this)
    this.next = this.next.bind(this)
    this.setpPosition = this.setpPosition.bind(this)
    this.clearAllBac = this.clearAllBac.bind(this)
    this.getClass = this.getClass.bind(this)
  }
  componentDidMount(){
    this.setpPosition()
    window.addEventListener('resize', this.setpPosition);
    let currentMast = $('.ant-modal-wrap')[0]
    if(currentMast){
      currentMast.addEventListener('scroll', this.setpPosition);
    }
    
  }
  cancel(){
    this.clearAllBac()
    this.props.cancel()
  }
  next(){
    const {currentPage} = this.state
    const newCurrent =currentPage+1
    this.setState({
        currentPage:newCurrent
    },()=>{
        this.setpPosition()
    })
  }
  setpPosition(){
    this.clearAllBac()
    const {currentPage} = this.state
    const {stepArray=[]} = this.props
    const currentCourse = stepArray[currentPage-1].course
    const currentIsOnBottom= stepArray[currentPage-1].isOnBottom
    const currentId = stepArray[currentPage-1].id
    const currentDom =$('#'+currentId)
    if(!currentDom)return
    if(currentDom){
      const top = (currentDom.offset().top-(stepArray.length>1?4:currentIsOnBottom?108:16))+'px'
      const left = (currentDom.offset().left-(currentCourse == 'right'?-40:265))+'px'
      currentDom.css('background','#EAEEF2')
      this.setState({
        top,
        left
      })
    }

  }
  clearAllBac(){
    const {stepArray=[]} = this.props
    stepArray.forEach(item=>{
        const currentDom =$('#'+item.id)
        currentDom.css('background','white')
    })
  }
  getClass(isTheme,course,isOnBottom){
    let classStr = 'guide'
    if(course){
      classStr+=`_${course}`
    }else{
      classStr+='_left'
    }
    if(isOnBottom){
      classStr += `_bottom` 
    }
    if(isTheme) {
      classStr += '_theme' 
    }
    classStr += '_item' 
    return classStr
  }
  render() {
    const {stepArray=[]} = this.props
    const {currentPage,top,left} = this.state
    const stepFlag = currentPage===stepArray.length
    const currentStep = stepArray[currentPage-1]
    const currentClass = this.getClass(currentStep.isTheme,currentStep.course,currentStep.isOnBottom)
    return (
      <div className={`guide_item ${currentClass}`} style={{left,top}}>
        <div className='guide_item_header' style={{color:stepArray[currentPage-1].isTheme?'white':'#2C2C2E'}}>
            {stepArray[currentPage-1].content}
        </div>
        <div className='guide_item_footer' >
            {stepArray.length>1?<p onClick={this.cancel}>{`${Strings.rs14095}(${currentPage}/${stepArray.length})`}</p>:<p></p>}
            <Button type={stepArray[currentPage-1].isTheme?'default':'primary'} onClick={stepFlag?this.cancel:this.next}>{stepFlag?Strings.rs14097:Strings.rs14096}</Button>
        </div>
      </div>
    )
  }
}
